import React from 'react';
import I18N from '@leverege/i18n';
import { FilterSourceModel, FilterSourcesModel } from "../../../filters/index.js";
import AttributeSortFieldModel from "../../../filters/sort/AttributeSortFieldModel.js";
import AttributeSortModel from "../../../filters/sort/AttributeSortModel.js";
import FilterSortMetadataModel from "../../../filters/filter/FilterSortMetadataModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tf,
  tIcon,
  tfIcon
} = I18N.ns('molten.dataViewers.table.SortAscendingAction');
export default {
  id: 'molten.dataViewers.table.SortAscendingAction',
  matches: {
    use: 'tableColumnHeaderActionBar',
    client: 'TableDataViewer'
  },
  layout: {
    sort: tf('sortValue'),
    group: [tf('filter')],
    groupIcons: [tfIcon('filterMenuIcon', 'fa fa-fw fa-chevron-down')]
  },
  handles: cxt => cxt.canSort,
  appearance: ({
    context: cxt
  }) => {
    const {
      isNumeric,
      isTimestamp,
      isBoolean
    } = cxt;
    const sort = t('sort');
    const arrowRight = tIcon('arrowRightIcon', 'fa fa-fw fa-arrow-right');
    const sortType = isTimestamp ? 'timestamp' : isNumeric ? 'numeric' : isBoolean ? 'boolean' : undefined;
    const leftSortValue = t('leftSortValue', {
      context: sortType
    });
    const rightSortValue = t('rightSortValue', {
      context: sortType
    });
    return {
      name: /*#__PURE__*/_jsxs(React.Fragment, {
        children: [sort, "\xA0", leftSortValue, /*#__PURE__*/_jsx("i", {
          className: arrowRight
        }), rightSortValue]
      }),
      icon: tIcon('sortAscendingAction')
    };
  },
  perform: ({
    context
  }) => {
    const {
      attribute: attr,
      clientProps: {
        filters,
        delegate,
        onFilterChange
      }
    } = context;
    const filter = FilterSourcesModel.getSource(filters, 'filterBar') || FilterSourceModel.create();
    const sort = AttributeSortFieldModel.create({
      order: 'asc',
      missing: '_first',
      attrName: attr.name
    });
    const metadata = filter?.metadata || FilterSortMetadataModel.create();
    const currentSorts = filter?.metadata?.sort?.fields;
    let nSortModel = filter?.metadata?.sort || AttributeSortModel.create();
    const matchingSortIndex = currentSorts?.findIndex(sort => sort.attrName === attr.name);
    if (matchingSortIndex > -1) {
      if (currentSorts[matchingSortIndex].order === 'asc') {
        nSortModel = AttributeSortModel.removeFieldAt(nSortModel, matchingSortIndex);
      } else {
        nSortModel = AttributeSortModel.setField(nSortModel, matchingSortIndex, sort);
      }
    } else if (currentSorts?.[0] && currentSorts?.[0]?.attrName == null) {
      nSortModel = AttributeSortModel.setField(nSortModel, 0, sort);
    } else {
      nSortModel = AttributeSortModel.addField(nSortModel, sort);
    }
    const nMetadata = FilterSortMetadataModel.setSort(metadata, nSortModel);
    const nSort = delegate?.convertToSort(nSortModel, context.clientProps);
    let nFilter = FilterSourceModel.setMetadata(filter, nMetadata);
    nFilter = FilterSourceModel.setSort(nFilter, nSort);
    onFilterChange({
      data: 'filterBar',
      value: nFilter
    });
    window.dispatchEvent(new CustomEvent(`molten.sortAsc.${attr.objectType}.open`));
  }
};